import { Button, Modal } from 'antd';
import { useUnit } from 'effector-react';
import {
  $liteBusiness,
  $restoreModal,
  confirmRestoreEv,
  resetRestoreMarkerEv,
  resetRestoreModalEv,
  sendCreateLitePresetFx,
} from '../../../models/rbpLiteModel/index.js';
import style from './RestoreModal.module.css';
import payment_business_types from '../../../data/payment_business_types.json';

function RestoreModal() {
  const restoreModal = useUnit($restoreModal);
  const resetRestoreModal = useUnit(resetRestoreModalEv);
  const liteBusiness = useUnit($liteBusiness);
  const pending = useUnit(sendCreateLitePresetFx.pending);
  const confirmRestore = useUnit(confirmRestoreEv);
  const resetRestoreMarker = useUnit(resetRestoreMarkerEv);

  let businessTitle = '';
  for (const item of payment_business_types) {
    const sub = item.subcategories.find(
      (subItem) =>
        subItem.uuid ===
        `t${liteBusiness.business}pt${liteBusiness.sub_business}`
    );
    if (sub) {
      businessTitle = sub.subtype;
    }
  }

  const close = () => {
    resetRestoreModal();
    resetRestoreMarker();
  };

  const confirm = () => {
    confirmRestore();
    resetRestoreMarker();
  };

  return (
    <Modal
      open={restoreModal}
      onCancel={close}
      footer={null}
      mask={false}
      maskClosable={false}
    >
      <div className={style.title}>
        Восстановить отчет по этой локации для типа бизнеса: <br />
        {businessTitle}
      </div>
      <div className={style.buttons_wrapper}>
        <Button type="primary" onClick={confirm} loading={pending}>
          Восстановить
        </Button>{' '}
        <Button onClick={close} disabled={pending}>
          Отмена
        </Button>
      </div>
    </Modal>
  );
}

export default RestoreModal;
